module.exports = __webpack_public_path__ + "img/logo4.36107143.png";